export let StripeElementsShortName = /*#__PURE__*/function (StripeElementsShortName) {
  StripeElementsShortName["NUMBER"] = "number";
  StripeElementsShortName["EXPIRY"] = "expiry";
  StripeElementsShortName["CVC"] = "cvc";
  return StripeElementsShortName;
}({});
export let StripeElementsValidationErrorCodes = /*#__PURE__*/function (StripeElementsValidationErrorCodes) {
  StripeElementsValidationErrorCodes["INCOMPLETE_NUMBER"] = "incomplete_number";
  StripeElementsValidationErrorCodes["INVALID_NUMBER"] = "invalid_number";
  StripeElementsValidationErrorCodes["INVALID_EXPIRY_YEAR_PAST"] = "invalid_expiry_year_past";
  StripeElementsValidationErrorCodes["INCOMPLETE_EXPIRY"] = "incomplete_expiry";
  StripeElementsValidationErrorCodes["INCOMPLETE_CVC"] = "incomplete_cvc";
  return StripeElementsValidationErrorCodes;
}({});